export default __webpack_public_path__ + "static/media/icon-ellipsis.a57a4ac8.svg";